import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  useTheme,
  BoxProps,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Download } from "@mui/icons-material";
import { QueryError } from "../../../types";
import { useSnackbar } from "../../../hooks/useSnackbar";

type Props = {
  value: { name: string; downloadId: string };
  download: (downloadId: string) => Promise<void>;
  fontSize?: string;
};

const DisplayMultipleFilesItem = ({ value, download, fontSize }: Props) => {
  const theme = useTheme();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { showErrorSnackbar } = useSnackbar();

  const handleDownload = async (id: string) => {
    try {
      setDownloadLoading(true);
      await download(id);
    } catch (error) {
      showErrorSnackbar(
        "Erreur dans le téléchargement.",
        "error",
        error instanceof QueryError ? error : undefined
      );
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="row" gap={"8px"}>
      <Typography
        fontSize={fontSize && fontSize}
        color="inherit"
        lineHeight={1.3}
        whiteSpace="pre-line"
        sx={{ wordBreak: "break-word" }}
      >
        {value.name}
      </Typography>
      {downloadLoading ? (
        <Box maxHeight={"1.5rem"} display="flex" alignItems="center">
          <CircularProgress size="1rem" />
        </Box>
      ) : (
        <IconButton
          onClick={() => handleDownload(value.downloadId)}
          sx={{
            fontSize: "1.0rem",
            padding: 0,
            paddingTop: "2px",
            "&:hover": {
              opacity: "0.7",
            },
          }}
          disableRipple={true}
        >
          <Download fontSize="inherit" />
        </IconButton>
      )}
    </Box>
  );
};

export default DisplayMultipleFilesItem;
